import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import 'jquery/dist/jquery.js';
import 'datatables.net-dt';
import '../node_modules/datatables.net-dt/css/dataTables.dataTables.min.css';
import '../node_modules/datatables.net-dt/js/dataTables.dataTables.min.js';
import './assets/css/fonts.css';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../src/assets/js/Custom.js';
import { Provider } from 'react-redux';
// import store from './store.js';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <div>
    {/* <Provider store={store}> */}
    <App />
    {/* </Provider> */}
  </div>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
